<ng-template [ngIf]="!loading"
    [ngIfElse]="placeholders">
    <ng-container *ngTemplateOutlet="content"></ng-container>
</ng-template>

<ng-template #content>
    <ng-template [ngIf]="!requireProduct || (requireProduct && selectedProductId)"
        [ngIfElse]="noProduct">
        <div class="productName__container">
            <span *ngIf="productName">{{ productName }}</span>
            <a class="changelog"
                (click)="showChangelog($event)"
                *ngIf="changelogEntries && changelogEntries.length > 0">
                {{ 'default.changelogProduct' | blah }}
            </a>
        </div>

        <div *ngIf="prefix === 'supplier'"
            class="guide">
            {{ 'default.catalogGuide' | blah }}
        </div>


        @if (viewCatalogs && viewCatalogs.length) {
            <div class="result-count-container"
                [ngClass]="{mobile: mobile}">
                @if (keyword?.length) {
                    <p>
                        {{'default.filteredByTitle' | blah}}
                        @if (viewCatalogs?.length) {
                            ({{displayedInstructionCount()}}/{{resultCount}})
                        }
                    </p>
                } @else {
                    <p>{{'default.resultCount' | blah:[resultCount]}}</p>
                }
            </div>
        }

        <ng-container *ngTemplateOutlet="list; context: {view: view, showAll: showAllInstructions, resultCount: resultCount, mode: 'normal'}">
        </ng-container>

        @if (showAiSearch && keyword.length && (keywordAi.length || aiSearchData === null)) {
            <div class="ai-search-results__container">
                <div class="result-count-container">
                    <p>
                        {{'default.searchedWithHelmi' | blah}}
                        @if (aiSearchData) {
                            ({{displayedInstructionCount('ai')}}/{{resultCountAi}})
                        }
                    </p>
                </div>

                @if (aiSearchData) {
                    <ng-container
                        *ngTemplateOutlet="list; context: {view: viewAi, showAll: showAllInstructionsAi, resultCount: resultCountAi, mode: 'ai'}">
                    </ng-container>
                } @else {
                    <div class="ai-search-results-loading">
                        <hpo-spinner size="24">
                        </hpo-spinner>
                        <div class="loading-text">{{'default.searching' | blah}}</div>
                    </div>
                }
            </div>
        }

    </ng-template>
</ng-template>

<ng-template #list
    let-view="view"
    let-showAll="showAll"
    let-resultCount="resultCount"
    let-mode="mode">
    @if (view && view.length) {
        <div class="wrapper">
            <div class="wrapper__content">
                <hpo-list>
                    @for (instruction of (showAll ? view : (view | slice:0:4)); track instruction.id) {
                        <hpo-list-item [ngClass]="{'lastClickedItem': lastClickedId === instruction.attributes.path.alias}">
                            <div class="catalogue-item">
                                <div class="icon">
                                    <img *ngIf="instruction.icon"
                                        [src]="instruction.icon.url"
                                        alt="Instruction icon" />
                                    <mat-icon *ngIf="!instruction.icon">article</mat-icon>
                                </div>
                                <div class="title">
                                    <div>
                                        <a routerLink="{{ instruction.attributes.path.alias }}"
                                            (click)="catalogContentClicked(instruction.attributes.path.alias)"
                                            [id]="instruction.attributes.path.alias">
                                            <span [ngClass]="{'lastClickedId': lastClickedId === instruction.attributes.path.alias}">
                                                {{ instruction.attributes.name }}</span></a>
                                    </div>
                                    <div class="title--category">
                                        <span *ngIf="instruction.category"
                                            class="title--category--text">{{ instruction.category }}</span>
                                        <div *ngFor="let icon of instruction.categoryIcons">
                                            <hpo-icon color="{{ icon }}">{{ icon }}</hpo-icon>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </hpo-list-item>
                    }
                    @if (resultCount > 4 && keyword.length) {
                        <div class="show-more-btn"
                            [ngClass]="{mobile: mobile}"
                            (click)="toggleViewAllInstructions(mode)">
                            @if (!showAll) {
                                <span>
                                    {{'default.showMore' | blah}}
                                    ({{ resultCount - displayedInstructionCount(mode) }})
                                </span>
                                <mat-icon>keyboard_arrow_down</mat-icon>
                            } @else {
                                <span>{{'default.showLess' | blah}}</span>
                                <mat-icon>keyboard_arrow_up</mat-icon>
                            }
                        </div>
                    }
                </hpo-list>
            </div>
        </div>
    } @else {
        @if (!loading) {
            <h2 class="catalog__backup-title">
                @if (mode === 'ai') {
                    {{ 'default.noInstructions' | blah }}
                } @else {
                    {{ 'default.noFilteredInstructionsFound' | blah }}
                }

            </h2>
        }
    }
</ng-template>

<ng-template #placeholders>
    <div class="catalog__placeholders">
        <hpo-placeholder type="row"></hpo-placeholder>
        <hpo-placeholder type="row"></hpo-placeholder>
        <hpo-placeholder type="row"></hpo-placeholder>
    </div>
</ng-template>

<ng-template #noProduct>
    <ng-container *ngIf="!loading">
        <h2 class="catalog__backup-title">{{ 'default.noProduct' | blah }}</h2>
    </ng-container>
</ng-template>